import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
  selector: "home-top-nav-bar",
  templateUrl: "./home-top-nav-bar.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeTopNavBarComponent {
  @Input()
  public navTitle: string;
}
